export default {
  app: {
    tradeOffers: {
      country: 'Country',
      loginPrompt: 'To see private trade offers, you need to {0}.',
      logIn: 'log in',
    },
  },
};
